import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';

import Table from "@material-ui/core/Table";
import img2 from "../logos/nodata.png";
import theme from '../theme';
import { useEffect } from 'react';
import {
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import './CommonDashboard.css'
import { setLicense } from '../redux/slices/licenseSlice';

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "#e0e0e0",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#fafafa",
    },
    "& .MuiDataGrid-cell": {
      fontWeight: "normal",
      fontSize: "0.875rem",
      color: "rgba(0, 0, 0, 0.87)",
      letterSpacing: "0.01071em",
    },
    "& .MuiDataGrid-cell--textLeft": {
      textAlign: "left",
    },
    "& .MuiDataGrid-cell--textCenter": {
      textAlign: "center",
    },
    "& .MuiDataGrid-cell--textRight": {
      textAlign: "right",
    },
    "& .MuiDataGrid-columnsContainer": {
      backgroundColor: "#fafafa",
    },
    "& .MuiDataGrid-iconSeparator": {
      display: "none",
    },
  },
  table: {
    marginLeft: theme.spacing(1), 
    marginRight: theme.spacing(1), 
    width: `calc(100% - ${theme.spacing(9)}px)`, 
  },
 
  
}));



const columns = [

  { field: 'key', headerName: 'License Key', flex:2 ,minWidth:300},
  { field: 'lastverified', headerName: 'Last Verified', flex:1 ,minWidth:150},
  { field: 'nextverified', headerName: 'Next Verified', flex:1 ,minWidth:150},
  {
    field: 'activationdate',
    headerName: 'Activation Date', 
    flex:1,
    minWidth:150
  },
  {
    field: 'expirationdate',
    headerName: 'Expiration Date',
    flex:1,
    minWidth:150
    
  },
  {
    field: 'valid',
    headerName: 'Valid ',
    flex:1,
    minWidth:100
  },
 

];

export default function License({errors}) {
  const [rows, setRows] = React.useState([]);
   const license = useSelector((state)=>state.license);
  const classes = useStyles();

  
  useEffect(() =>{
   
     if(license.license)
       setRows(license.license);
    
      
  },[license.license]);

  return (
    <>
      {rows?.length > 0 && errors ===false ? (
        
          <ThemeProvider theme={theme}>
            <Table classes={classes.table}>
              <div className="emms-data-grid-container" style={{ padding: "2.5% 10%" }}>
                <DataGrid
                  rows={rows}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 5,
                      },
                    },
                  }}
                  pageSizeOptions={[5]}
                  checkboxSelection
                  disableRowSelectionOnClick
                  sx={{
                    maxWidth:"100vw"
                  }}
                />
              </div>
            </Table>
          </ThemeProvider>
        
      ) : (
          <div className="error-container"> 
             <img src={img2} className="img"/>
          </div>
      )}
    </>
  );
}
